import React from 'react'

export const DigitalLib = () => {
  return (
    <div className='content'>DigitalLib</div>
  )
}
